import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  border-radius: 12px;
  border: solid 2px ${({ theme }) => theme.primaryBackgroundColor};
  background: ${({ theme }) => theme.confirmationModal.buttonBackground};
  color: ${({ theme }) => theme.primaryBackgroundColor};
  margin-top: 8px;
  width: 100%;
  height: 50px;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.53;
  letter-spacing: -0.1px;
  text-align: center;
  cursor: pointer;
`;
